
export default function Footer() {

    return (
        <footer className="bg-gray-800 text-white p-4 ">
        
        </footer>
    )
}